import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import {
  Container,
  Content,
  Information,
  Wrapper,
  InformationWrapper,
  ImageWrapper,
} from '@components/Internship/Declaration/styles';
import { DescriptionList, SectionHeader } from '@components/Internship/Assumptions/styles';

import TextHeader, { SIZE, TAG, WEIGHT } from '@components/TextHeader';
import Link from '@components/Link';

import DeclarationBackground from '@assets/images/mask-group.svg';

function Declaration() {
  const { t } = useTranslation('internship');
  return (
    <Container>
      <Wrapper>
        <TextHeader size={SIZE.LG} weight={WEIGHT.NORMAL} tag={TAG.H2}>
          {t('Declaration of partners')}
        </TextHeader>
        <Content>
          <InformationWrapper>
            <Information dangerouslySetInnerHTML={{ __html: t('Declaration desc') }} />
            <Link href={t('Declaration Link')}>{t('Declaration Copy')}</Link>
            <SectionHeader style={{ marginTop: 32 }}>{t('BENEFITS FOR INTERNSHIP FOUNDERS')}</SectionHeader>
            <DescriptionList dangerouslySetInnerHTML={{ __html: t('Benefits list') }} />
          </InformationWrapper>
          <ImageWrapper>
            <Image src={DeclarationBackground} />
          </ImageWrapper>
        </Content>
      </Wrapper>
    </Container>
  );
}

export default Declaration;
